import axios from 'axios'
import qs from 'qs'

let token = getVal('token')
let mobileType = getVal('mobileType')
let defCommunityId = getVal('defCommunityId')
let companyCode = getVal('companyCode')
// axios 配置
axios.defaults.timeout = 5000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers['companyCode'] = companyCode
axios.defaults.headers['defCommunityId'] = defCommunityId
if (token !== '') {
  axios.defaults.headers['token'] = token
}
if (mobileType !== '') {
  axios.defaults.headers['mobileType'] = mobileType
}
axios.defaults.headers['sign'] = getVal('sign')
axios.defaults.headers['ignoreSign'] = 1
axios.defaults.baseURL = baseUrl// 'http://192.168.10.137:8088/uama-town' // 'http://192.168.20.23:8081/uama-town/' //

// POST传参序列化
axios.interceptors.request.use((config) => {
  if (config.method === 'post') {
    config.data = qs.stringify(config.data)
  }
  return config
}, (error) => {
    // _.toast("错误的传参", 'fail')
  return Promise.reject(error)
})

// 返回状态判断
axios.interceptors.response.use((res) => {
  if (!res.data.status === '100' || res.data.status === 106) {
    alert(res.data.msg)
    return Promise.reject(res)
  }
  return res.data
}, (error) => {
    // _.toast("网络异常", 'fail')
  return Promise.reject(error)
})

export function fetch (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
        .then(response => {
          resolve(response.data)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
  })
}

export function fetchPost (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
        .then(response => {
          resolve(response)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
  })
}

export function fetchGet (url, params) {
  return new Promise((resolve, reject) => {
    let param = ''
    for (let v in params) {
      param = '/' + params[v]
    }
    console.log(param)
    axios.get(url + param)
        .then(response => {
          resolve(response.data)
        }, err => {
          reject(err)
        })
        .catch((error) => {
          reject(error)
        })
  })
}

export function getRouterParam (name) {
  var params = window.location.href.split('?')[1]
  if (params == null || params === undefined || typeof (params) === undefined) {
    return ''
  }
  var paramList = []
  var param = null
  var theRequest = { }
  if (params.length > 0) {
    if (params.indexOf('&') >= 0) {
      paramList = params.split('&')
    } else {
      paramList[0] = params
    }
    for (var i = 0; i < paramList.length; i++) {
      theRequest[paramList[i].split('=')[0]] = (paramList[i].split('=')[1])
    }
    param = theRequest[name]
  }
  return param
}

export function getVal (key) {
  var value = getRouterParam(key)
  if (value === undefined || typeof (value) === undefined || value == null) {
    return ''
  }
  return value
}

export default {
  qs,
  axios,
  // 获取url传递的参数
  getVal (key) {
    var value = getRouterParam(key)
    if (value === undefined || typeof (value) === undefined || value == null) {
      return ''
    }
    return value
  },

    /**
     * 获取新闻公告list
     */
  GetNewList (params) {
    return fetch('wgAdminView2Action!projectList.action', params)
  },
  /**
   * 职位详情
   */
  GetPosition (params) {
    return fetchGet('headhunter/user/positionDetail', params)
  },
  /**
   * 提交简历
   */
  PostResume (params) {
    return fetchPost('headhunter/user/inviteResume', params)
  },
  /**
   * 获取租房详情
   */
  GetRentDetailsInfo (params) {
    return fetchGet('settleDown/officialRentDetailsInfo', params)
  },
  /**
   * 获取楼盘详情
   */
  GetPremisesDetailsInfo (params) {
    return fetchGet('settleDown/getPremisesDetailsInfo', params)
  },
  /**
   * 获取项目介绍
   */
  GetCommunityDetail (params) {
    return fetch('website/communityDetail', params)
  },
  /**
   * 获取小镇地图详情
   */
  GetMapDetail (params) {
    return fetch('v10/website/communityPic', params)
  },
    /**
   * 获取小镇基本情况
   */
  GetTownInfo (params) {
    return fetch('v10/website/communitydetail', params)
  },
  /**
   * 获取入驻企业列表
   */
  GetCompanyList (params) {
    return fetch('v10/website/enterprise/list', params)
  },
  /**
   * 获取通知详情
   */
  GetNoticeDetail (params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'notice/h5/getNoticeDetail?' + qs.stringify(params)
      }).then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  /**
   * 设置通知详情为已读
   */
  ReadNoticeDetail (params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'notice/h5/updateNotice?' + qs.stringify(params),
        method: 'put'
      }).then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },
  /**
   * 获取协议详情(富文本)
   */
  getProtocolDetail (url, params) {
    return new Promise((resolve, reject) => {
      axios({
        url,
        params
      }).then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/script/util.js